import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.Toolbar', {
    newBankAccount: 'New bank account',
});
